import type { ElementFormatType } from 'lexical';
import type { LucideIcon } from 'lucide-react';
import { AlignCenter, AlignJustify, AlignLeft, AlignRight } from 'lucide-react';

/** Block alignments, shared by the paragraph toolbar and the image toolbar (which omits `justify`). */
export const ALIGNMENTS = [
  { value: 'left', icon: AlignLeft, labelKey: 'editor.toolbar.align-left' },
  { value: 'center', icon: AlignCenter, labelKey: 'editor.toolbar.align-center' },
  { value: 'right', icon: AlignRight, labelKey: 'editor.toolbar.align-right' },
  { value: 'justify', icon: AlignJustify, labelKey: 'editor.toolbar.align-justify' },
] as const satisfies readonly { value: Exclude<ElementFormatType, ''>; icon: LucideIcon; labelKey: string }[];
